import Request from '@/utils/request'

// 9.99充值活动
export function apiNinePointNinetyNineAct (params) {
  return Request({
    url: '/api/v2/app/shop/activity/18/cfg',
    method: 'get',
    params
  })
}

export function apiNinePointNinetyNineDraw () {
  return Request({
    url: '/api/v2/app/shop/activity/18/draw',
    method: 'post'
  })
}